<div class=" p-3">
    <div class="page-header mb-4">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h4 class="mb-1">
                    {{ schemeType === 'tdf' ? 'Approval' : 'Examination of Proposal at NHQ' }}
                </h4>
                <h5 class="text-primary">[{{payload?.proposal_name}}]</h5>
                <div class="status-badge">
                    <span class="badge" [ngClass]="{
                        'bg-secondary': stepDetails?.step_status == 0,
                        'bg-success': stepDetails?.step_status == 'approved',
                        'bg-warning': stepDetails?.step_status == 'recommended',
                        'bg-info': stepDetails?.step_status == 'initiated'
                    }">
                        {{
                        stepDetails?.step_status == 0
                        ? 'INITIATION PENDING'
                        : (stepDetails?.step_status | uppercase)
                        }}
                    </span>
                </div>
            </div>

            <!-- <div class="action-buttons" *ngIf="status === 'received'"> -->
            <div class="action-buttons">
                <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
                    <i class="pi pi-file-pdf me-1"></i> PDF
                </button>

                <ng-container *ngIf="stepDetails?.step_status == 'approved'">
                    <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
                        Next <i class="pi pi-angle-right ms-1"></i>
                    </button>
                </ng-container>

                <ng-container
                    *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
                    <button class="btn btn-primary me-2" (click)="onSubmit()"  [disabled]="(schemeType === 'TDF' && proposalForm?.invalid) || 
                (schemeType !== 'TDF' && challengeForm?.invalid)">
                        <i class="pi pi-save me-1"></i> Save
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_initiator">
                    <button class="btn btn-success" (click)="IRA.emit('Initiate')">
                        <i class="pi pi-play me-1"></i> Initiate
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_approver">
                    <button class="btn btn-success" (click)="IRA.emit('Approve')">
                        <i class="pi pi-check-circle me-1"></i> Approve
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_recommender">
                    <button class="btn btn-info" (click)="IRA.emit('Recommend')">
                        <i class="pi pi-thumbs-up me-1"></i> Recommend
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <hr class="my-3">
    <div class=" row p-4">



        <!-- Status Radio Buttons -->
        <!-- <div class="col-6  row justify-content-center align-items-center mb-4">
            <div class="col-auto">
                <label class="col-form-label fw-bold">Status:</label>
            </div>
            <div class="col-auto d-flex gap-3">
                <div class="form-check">
                    <label for="received ">Received</label>
                    <div class="form-check">
                        <p-radioButton name="status" value="received" label="Received" [(ngModel)]="status"
                            inputId="received" (onClick)="toggleReceived()">
                        </p-radioButton>
                    </div>
                </div>

                <div class="form-check">
                    <label for="notReceived">Not Received</label>
                    <div class="form-check">
                        <p-radioButton name="status" value="notReceived" label="Not Received" [(ngModel)]="status"
                            inputId="notReceived" (onClick)="toggleReceived()">
                        </p-radioButton>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Related Item AutoComplete -->
        <!-- <div *ngIf="status === 'received' && currentUserCode == 'DADMIN'" class=" col-6 row mb-3"> -->
        <div *ngIf="currentUserCode == 'DADMIN'" class=" col-6 row mb-3">
            <div class="col-md-12">
                <label for="relatedItem" class="form-label ms-1 fw-bold">Select Professional Directorate</label>
                <!-- <p-autoComplete [(ngModel)]="selectedItem" placeholder="Search & Select Item"
                    [style]="{'width':'100%', 'padding':'10px'}" [dropdown]="true" [suggestions]="filteredItems"
                    optionLabel="first_name" (completeMethod)="searchItems($event)" inputId="relatedItem">
                </p-autoComplete> -->

                 <p-dropdown [(ngModel)]="selectedItem" [options]="items" optionLabel="first_name"
                    placeholder="Search & Select Item" [style]="{'width':'100%'}"
                    inputId="relatedItem" [filter]="true" filterBy="first_name">
                </p-dropdown>


            </div>
            <div class="col-auto p-left-22 mt-2">
                <!-- <p-button label="Send for Professional Directorate" icon="pi pi-send" *ngIf="status === 'received'"
                    [outlined]="true" (click)="onSubmit()"></p-button> -->
                <p-button label="Send for Professional Directorate" icon="pi pi-send"
                    [outlined]="true" (click)="onSubmit()"></p-button>
            </div>
        </div>



    </div>

      <!-- <div class="form-wrapper" *ngIf="status == 'received'"> -->
      <div class="form-wrapper">
        <ng-container *ngIf="schemeType != 'tdf'">
            <form [formGroup]="challengeForm" (ngSubmit)="onSubmit()">
                <!-- Section A: Nodal Agency Details -->
                <div class="card mb-4">
                    <div class="card-header bg-light">
                        <h5>A. Nodal Agency Details<span class="text-danger">*</span></h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">Organisation</label>
                                <input type="text" class="form-control" formControlName="organisation">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Category (DISC/PRIME/ADITI/OC)</label>
                                <input type="text" class="form-control" formControlName="category">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Release Date</label>
                                <input type="date" class="form-control" formControlName="releaseDate">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Approved By (APSO)</label>
                                <input type="text" class="form-control" formControlName="approvedBy">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Coordinating Agency</label>
                                <input type="text" class="form-control" formControlName="coordinatingAgency">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Technology Domain</label>
                                <input type="text" class="form-control" formControlName="technologyDomain">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Section B: Problem Statement -->
                <div class="card mb-4">
                    <div class="card-header bg-light">
                        <h5>B. Problem Statement for iDEX Challenge</h5>
                    </div>
                    <div class="card-body">
                        <div class="mb-4">
                            <label class="form-label">CHALLENGE TITLE<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="challengeTitle">
                        </div>

                        <div class="mb-4">
                            <label class="form-label">Problem Statement<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="problemStatement">
                        </div>

                        <div class="rich-text-section"  [class.readonly-editor]="isEditorDisabled">
                            <label class="form-label">• Challenge Brief/ Definition<span class="text-danger">*</span></label>
                            <editor [init]="init" formControlName="pdsTitle" [disabled]="isEditorDisabled"></editor>
                        </div>

                        <div class="rich-text-section"  [class.readonly-editor]="isEditorDisabled">
                            <label class="form-label">• Future Expectation from the prototype development<span class="text-danger">*</span></label>
                            <editor [init]="init" formControlName="pdsDefinition" [disabled]="isEditorDisabled">
                            </editor>
                        </div>

                        <!-- Additional sections in accordion for better organization -->
                        <div class="accordion mb-3" id="challengeDetailsAccordion">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#additionalDetails">
                                        Additional Challenge Details
                                    </button>
                                </h2>
                                <div id="additionalDetails" class="accordion-collapse collapse">
                                    <div class="accordion-body">
                                        <div class="rich-text-section"  [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label">• Need/Requirement of the proposed
                                                challenge<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="qrs" [disabled]="isEditorDisabled">
                                            </editor>
                                        </div>

                                        <div class="rich-text-section"  [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label">• IP Value</label>
                                            <editor [init]="init" formControlName="developmentPlatforms"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>

                                        <!-- Include all other rich text sections here -->
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="targetPlatform">• Functional
                                                Advantages<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="targetPlatform"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="functions">• Domestic Capability
                                                Development<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="functions"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                       Concurrence by APSO     <label class="form-label" for="testProcedureOutcome">• Import Substitution
                                                (Reliability and Flexibility of existing source of import)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="testProcedureOutcome"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <!-- <div class="rich-text-section"> -->
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="testPlan">• Preliminary scope of solution
                                                being developed<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="testPlan"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="endUserTrials">• Global competitive nature of
                                                the problem including novelty of the solution (from user
                                                prospective)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="endUserTrials"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="qaStandards">• Potential Market for
                                                product/technology (from user perspective)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="qaStandards"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="form-label" class="rich-text-section"
                                            [class.readonly-editor]="isEditorDisabled">
                                            <label for="testSites">• Risk Assessment<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="testSites"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="waiverClauses">• Pilot Procurement Plan with
                                                Minimum Pilot Order Quality(MPQ)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="waiverClauses"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>

        <!-- TDF Specific Form -->
        <ng-container *ngIf="schemeType == 'tdf'">
              <form [formGroup]="proposalForm">
        <div class="form-group row mb-4" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Title of the Requirement<b class="text-danger">*</b>

            </label>
            <editor [init]="init" formControlName="technologyInsertion" [disabled]="isEditorDisabled">
            </editor>
        </div>

        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Description of major system/sub-system and where the item/
                product is to be utilised/fitted. <b class="text-danger">*</b>

            </label>
            <editor [init]="init" formControlName="justificationText" [disabled]="isEditorDisabled">
            </editor>
        </div>

        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Reason for pursuing project under TDF scheme.<b class="text-danger">*</b>

            </label>
            <editor [init]="init" formControlName="exportPotential" [disabled]="isEditorDisabled">
            </editor>
        </div>

        <!-- <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Technology Area (Discipline, Sub-discipline)<b class="text-danger">*</b>

            </label>
            <editor [init]="init" formControlName="stakeholderDiscussions" [disabled]="isEditorDisabled"></editor>
        </div> -->

        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Objective (to cover product/ system/ Item)<b class="text-danger">*</b>

            </label>
            <editor [init]="init" formControlName="objective" [disabled]="isEditorDisabled">
            </editor>
        </div>

        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Description & Details of existing system and its use <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="existingSystem" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Functional and Operational requirements in qualitative terms <b
                    class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="functionalRequirements" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Contemporary solutions known nationally and/or internationally
                (if nil, then source of idea) <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="contemporarySolutions" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Miscellaneous Information <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="miscellaneousInfo" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">References <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="references" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Keywords <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="keywords" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Estimated requirement for the Indian Navy over 03 to 05 years <b
                    class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="estimatedRequirement" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Testing Methodology, Free Issue Material, Acceptance Criteria/
                Type Tests Required / Venue of testing.<b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="testingMethodology" [disabled]="isEditorDisabled">
            </editor>
        </div>
        v
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Likely Civil Spin Offs <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="civilSpinOffs" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Technology Readiness Level<b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="technologyReadinessLevel" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Proposal is an equipment/ spare, is it an import substitution/
                replacement/ upgradation/ new induction. Explain <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="proposalExplanation" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">QA Agency <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="qaAgency" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Concurrence by APSO <b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="apsoConcurrence" [disabled]="isEditorDisabled">
            </editor>
        </div>
        <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">PQSR<b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="pqsr" [disabled]="isEditorDisabled">
            </editor>
        </div>
         <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Additional Information<b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="additionalInformation" [disabled]="isEditorDisabled">
            </editor>
        </div>
         <div class="form-group row mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">Quantity Required<b class="text-danger"></b>

            </label>
            <editor [init]="init" formControlName="quantityRequired" [disabled]="isEditorDisabled">
            </editor>
        </div>

        <ng-container *ngIf="needGenData?.upload_photograph">
            <h3 class="mt-4">Uploaded Photograph</h3>
            <ul>
                <li><a href="{{ apiUrl + needGenData?.upload_photograph}}" target="_blank"
                        rel="noopener noreferrer">{{getFileName(needGenData?.upload_photograph)}}</a></li>
            </ul>
        </ng-container>
        <ng-container *ngIf="needGenData?.feasibility_study">
            <h3 class="mt-4">Uploaded Supporting Documents</h3>
            <ul>
                <li><a href="{{ apiUrl + needGenData?.feasibility_study}}" target="_blank"
                        rel="noopener noreferrer">{{getFileName(needGenData?.feasibility_study)}}</a></li>
            </ul>
        </ng-container>
    </form>
        </ng-container>
    </div>

  
</div>